angular.module('bribac.components.searchForm', [
  'bribac.values'
])

  .component('searchForm', {
    templateUrl: 'search-form-component.html',
    controller: 'SearchFormCtrl',
    bindings: {
      query: '<'
    }
  })

  .controller('SearchFormCtrl', function(
    $scope,
    $location,
    SEARCH_QUERY_MINLENGTH
  ) {
    var $ctrl = this

    $ctrl.SEARCH_QUERY_MINLENGTH = SEARCH_QUERY_MINLENGTH
    $ctrl.translationValues = {
      minLength: SEARCH_QUERY_MINLENGTH
    }

    $ctrl.onSubmit = function() {
      var $form = $scope.form

      if ($form.$invalid) {
        return
      }

      if ($location.path() === '/search') {
        $location.search('query', $ctrl.query)
        $form.$setPristine()
        $form.$setUntouched()
      } else {
        $location.url('/search/?query=' + $ctrl.query)
      }
    }
  })
